export default function getItemsAlignment(alignment) {
    switch (alignment) {
        case "start": {
            return "flex-start";
        }
        case "end": {
            return "flex-end";
        }
        default: {
            return "center";
        }
    }
}
//# sourceMappingURL=get-items-alignment.js.map